/**
 * 坐标工具函数
 */
/**
 * 检查坐标是否相等
 */
export function coordinatesEqual(a, b) {
    return a.x === b.x && a.y === b.y;
}
/**
 * 检查坐标是否在数组中
 */
export function coordinateInArray(coord, array) {
    return array.some(c => coordinatesEqual(c, coord));
}
/**
 * 坐标转换为字符串
 */
export function coordinateToString(coord) {
    return `${coord.x},${coord.y}`;
}
/**
 * 字符串转换为坐标
 */
export function stringToCoordinate(str) {
    const [x, y] = str.split(',').map(Number);
    return { x, y };
}
/**
 * 获取坐标的哈希值
 */
export function coordinateHash(coord) {
    return coord.x * 1000 + coord.y;
}
/**
 * 坐标数组去重
 */
export function uniqueCoordinates(coords) {
    const seen = new Set();
    const result = [];
    for (const coord of coords) {
        const key = coordinateToString(coord);
        if (!seen.has(key)) {
            seen.add(key);
            result.push(coord);
        }
    }
    return result;
}
/**
 * 坐标数组排序
 */
export function sortCoordinates(coords) {
    return [...coords].sort((a, b) => {
        if (a.y !== b.y)
            return a.y - b.y;
        return a.x - b.x;
    });
}
/**
 * 计算坐标距离
 */
export function coordinateDistance(a, b) {
    return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
}
/**
 * 获取坐标的相邻坐标
 */
export function getNeighborCoordinates(coord, boardSize) {
    const neighbors = [];
    const directions = [
        { dx: 0, dy: -1 }, // 上
        { dx: 1, dy: 0 }, // 右
        { dx: 0, dy: 1 }, // 下
        { dx: -1, dy: 0 } // 左
    ];
    for (const dir of directions) {
        const nx = coord.x + dir.dx;
        const ny = coord.y + dir.dy;
        if (nx >= 1 && nx <= boardSize && ny >= 1 && ny <= boardSize) {
            neighbors.push({ x: nx, y: ny });
        }
    }
    return neighbors;
}
/**
 * 获取坐标的对角线坐标
 */
export function getDiagonalCoordinates(coord, boardSize) {
    const diagonals = [];
    const directions = [
        { dx: -1, dy: -1 }, // 左上
        { dx: 1, dy: -1 }, // 右上
        { dx: -1, dy: 1 }, // 左下
        { dx: 1, dy: 1 } // 右下
    ];
    for (const dir of directions) {
        const nx = coord.x + dir.dx;
        const ny = coord.y + dir.dy;
        if (nx >= 1 && nx <= boardSize && ny >= 1 && ny <= boardSize) {
            diagonals.push({ x: nx, y: ny });
        }
    }
    return diagonals;
}
/**
 * 坐标转换为SGF格式
 */
export function coordinateToSGF(coord) {
    if (coord === null)
        return '';
    const xChar = String.fromCharCode('a'.charCodeAt(0) + coord.x - 1);
    const yChar = String.fromCharCode('a'.charCodeAt(0) + coord.y - 1);
    return `${xChar}${yChar}`;
}
/**
 * SGF格式转换为坐标
 */
export function sgfToCoordinate(sgfCoord) {
    if (!sgfCoord || sgfCoord === '')
        return null;
    const x = sgfCoord.charCodeAt(0) - 'a'.charCodeAt(0) + 1;
    const y = sgfCoord.charCodeAt(1) - 'a'.charCodeAt(0) + 1;
    return { x, y };
}
/**
 * 坐标转换为棋谱 notation (如: D4)
 */
export function coordinateToNotation(coord) {
    const letters = 'ABCDEFGHJKLMNOPQRST';
    const x = letters[coord.x - 1];
    const y = coord.y;
    return `${x}${y}`;
}
/**
 * 棋谱 notation 转换为坐标
 */
export function notationToCoordinate(notation) {
    const letters = 'ABCDEFGHJKLMNOPQRST';
    const x = letters.indexOf(notation[0].toUpperCase()) + 1;
    const y = parseInt(notation.slice(1), 10);
    if (x === 0 || isNaN(y)) {
        throw new Error(`无效的棋谱表示: ${notation}`);
    }
    return { x, y };
}
/**
 * 生成所有棋盘坐标
 */
export function generateAllCoordinates(boardSize) {
    const coords = [];
    for (let y = 1; y <= boardSize; y++) {
        for (let x = 1; x <= boardSize; x++) {
            coords.push({ x, y });
        }
    }
    return coords;
}
/**
 * 坐标数组转换为二维数组
 */
export function coordinatesToMatrix(coords, boardSize, value = true) {
    const matrix = [];
    for (let y = 0; y < boardSize; y++) {
        matrix[y] = new Array(boardSize).fill(false);
    }
    for (const coord of coords) {
        matrix[coord.y - 1][coord.x - 1] = value;
    }
    return matrix;
}
/**
 * 二维数组转换为坐标数组
 */
export function matrixToCoordinates(matrix) {
    const coords = [];
    for (let y = 0; y < matrix.length; y++) {
        for (let x = 0; x < matrix[y].length; x++) {
            if (matrix[y][x]) {
                coords.push({ x: x + 1, y: y + 1 });
            }
        }
    }
    return coords;
}
//# sourceMappingURL=coordinate.js.map